import { commaListSchema } from "@birdwatch/common";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { OnboardingViewComponent as OnboardingView } from "@/features/office/places/onboarding";
import { OnboardingDisplayOptionsProvider } from "@/features/office/places/onboarding/header/_hooks/use-onboarding-display-options";
import {
  filterSearchFragment,
  notificationSearchFragment,
  withOperators,
} from "@/features/shared/filters-new";
import { maskSearchFragment } from "@/features/shared/route-masking";

const querySchema = z.object({
  search: z.string().optional(),
  ...filterSearchFragment,
  filters: z
    .object({
      status: withOperators(commaListSchema),
      planKey: withOperators(commaListSchema),
      ...notificationSearchFragment,
    })
    .optional(),
  sort: z.string().optional(),
  groupBy: z.string().optional(),
  scope: z.enum(["active", "all"]).optional(),
  "collapse-empty": z.string().optional(),
  hide: z.string().optional(),
  "close-column": commaListSchema,
  ...maskSearchFragment,
});

export const routeId = "/office/places/onboarding/";

export const Route = createFileRoute("/office/places/onboarding/")({
  validateSearch: querySchema,
  component: OnboardingOnboardingPage,
});

function OnboardingOnboardingPage() {
  return (
    <OnboardingDisplayOptionsProvider>
      <OnboardingView />
    </OnboardingDisplayOptionsProvider>
  );
}
